import { AppBar, Toolbar } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import DehazeIcon from '@mui/icons-material/Dehaze';
import MapIcon from '@mui/icons-material/Map';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useTranslation } from "react-i18next";
import { Link } from 'react-router-dom';

const Header = (props) => {
    const {display , title , isList ,toggleList , displayList = true } = props;
    const { t } = useTranslation();

    const clickBtnListMap = () => {
        toggleList(!isList);
    }

    if(display){
        return (
            <Box sx={{ flexGrow: 1 }}>
            <header>
            <AppBar position="static">
                <Toolbar variant="dense" disableGutters sx={{ display: "flex", justifyContent: "space-between" }}>
                    <Typography className="header-left">
                    <Link to="/">
                    <IconButton
                        edge="end"
                        color="inherit"
                        aria-label="menu"
                        className="header-list"
                        >
                        <img className="home" alt="HOME" src="/assets/images/others/hd-home-active@3x.png"/>
                    </IconButton>
                    </Link>

                    </Typography>
                    <Typography className="header-title">{title}</Typography>
                    {
                    displayList?
                    isList?
                    <IconButton
                        edge="end"
                        color="inherit"
                        aria-label="menu"
                        className="header-list"
                        onClick={clickBtnListMap}
                        size="large">
                        <MapIcon />
                        {t("header.map")}
                    </IconButton>:
                    <IconButton
                        edge="end"
                        color="inherit"
                        aria-label="menu"
                        className="header-list"
                        onClick={clickBtnListMap}
                        size="large">
                        <DehazeIcon />
                        {t("header.list")}
                    </IconButton>
                    :
                    <Typography className="header-left"></Typography>
                    }
                </Toolbar>
            </AppBar>
            </header>
            </Box>
        );
    }else{
        return (<Box sx={{ flexGrow: 1 }}></Box>);
    }
};
export default Header